import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/authGuard/auth-guard';
import { Help } from './root/help/help';

export const routes: Routes = [
	{
      path: 'auth',
      loadChildren: () => import('./modules/authentication/authentication-module').then(m => m.AuthenticationModule)
  },
  {
      path: 'help',
      component: Help
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/main-layout/main-layout-module').then(m => m.MainLayoutModule)
  },
  { path: '**', redirectTo: '' },
];
